import Plus from './Plus';

export default Plus;
